import type { ReactNode } from "react";
import { FileImage, FileText, LockKeyhole } from "lucide-react";
import { Row } from "./Row";
import { StatusChip } from "./StatusChip";
import { Stack } from "./Stack";
import { Text } from "./Text";

export function fileSizeLabel(bytes: number) {
  if (!Number.isFinite(bytes) || bytes < 0) return "Size unavailable";
  if (bytes < 1024) return `${bytes} B`;
  return bytes < 1024 * 1024 ? `${(bytes / 1024).toFixed(1)} KB` : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
export type FileRowProps = { filename: string; contentType: string; size: number; kind: string; detail?: string; attribution?: string; linked?: boolean; onOpen?: () => void; disabled?: boolean; actions?: ReactNode; findings?: ReactNode };

export function FileRow({ filename, contentType, size, kind, detail, attribution, linked = false, onOpen, disabled, actions, findings }: FileRowProps) {
  return <Row icon={linked ? <LockKeyhole aria-hidden size={21} /> : contentType.startsWith("image/") ? <FileImage aria-hidden size={21} /> : <FileText aria-hidden size={21} />} title={filename} wrap
    subtitle={<Stack gap={1}><Text as="span" variant="caption" tone="secondary">{[fileSizeLabel(size), detail, linked ? "Linked document · retained" : null].filter(Boolean).join(" · ")}</Text>{attribution && <Text as="span" variant="caption" tone="secondary">{attribution}</Text>}{findings}</Stack>}
    trailing={<StatusChip tone={linked ? "accent" : "neutral"}>{kind.replaceAll("_", " ")}</StatusChip>} onClick={onOpen} disabled={disabled} actions={actions} />;
}
